/**
 * Checks that a value is not null or undefined and narrows its type
 * @param value
 */
export function isNotNullable(value) {
    return value != null;
}
